import * as React from "react"
import Svg, { G, Rect, Path } from "react-native-svg"
/* SVGR has dropped some elements not supported by react-native-svg: title */

function Close(props) {
    const { size, color, backgroundColor, ...rest } = props

    return (
        <Svg width={16} height={16} xmlns="http://www.w3.org/2000/svg" {...rest}>
            <G transform="translate(-963 -18)" fill="none" fillRule="evenodd">
                <Rect
                    stroke="#7EBC56"
                    strokeWidth={3}
                    fill="#FFF"
                    x={1.5}
                    y={1.5}
                    width={1001}
                    height={335}
                    rx={16}
                />
                <Path
                    d="M965.182 18a.724.724 0 0 0-.514.213l-1.455 1.455a.726.726 0 0 0 0 1.028L968.517 26l-5.304 5.304a.726.726 0 0 0 0 1.028l1.455 1.455a.726.726 0 0 0 1.028 0L971 28.483l5.304 5.304a.726.726 0 0 0 1.028 0l1.455-1.455a.726.726 0 0 0 0-1.028L973.483 26l5.304-5.304a.726.726 0 0 0 0-1.028l-1.455-1.455a.726.726 0 0 0-1.028 0L971 23.517l-5.304-5.304a.725.725 0 0 0-.514-.213Z"
                    fill="#000"
                    fillRule="nonzero"
                />
            </G>
        </Svg>
    )
}

export default Close